import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/slcp/(pages)')({
  // Layout route for every SLCP screen, so the read permission is asked once
  // here rather than on each child route.
  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.slcp.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    const path = location.pathname.replace(/\/$/, '');
    // None of these are real pages — each is only a breadcrumb anchor or a
    // layout with no index of its own, so landing on one renders an empty
    // outlet. `/slcp/my-own` is the middle crumb on every My Own screen, which
    // made it a dead link in the trail (BI-1802). Send them all to the default
    // list view.
    if (
      path === '/slcp' ||
      path === '/slcp/assessments' ||
      path === '/slcp/my-own'
    ) {
      throw redirect({ to: '/slcp/my-own/active' });
    }
  },
});
